/** @jsxRuntime classic */ // <-- remove this when TS updated to 4.1
/** @jsx jsx */ // <-- remove this when TS updated to 4.1
import { jsx } from '@emotion/core';
import { useTheme } from 'emotion-theming';
import { Fragment, ReactNode } from 'react';
import { Card, GlobalStyles, Header } from '../..';
import { ThemeProps } from '../../../types';

interface AppContainerProps {
  /**
   * Button contents
   */
  children: ReactNode;
}

const AppContainer = ({ children }: AppContainerProps) => {
  const theme: ThemeProps = useTheme();

  return (
    <Fragment>
      <GlobalStyles />
      <Header
        headerIcon={
            theme.images?.icon
        }
      />
      <Card
        css={{
          [theme.mq.desktop]: {
            marginBottom: 30,
            marginTop: 30,
          },
        }}>
        {children}
      </Card>
    </Fragment>
  );
};

export default AppContainer;
